
import styled from "styled-components";

export const Wrapper = styled.nav`
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
`;

export const BtnWrapper = styled.div`
  max-width: 190px;
  @media (max-width: 960px) {
    margin: 0 auto;
  }
`;

export const NavInner = styled.div`
  position: relative;
  height: 100%;
`;

export const UlWrapper = styled.ul`
  display: flex;
  @media (max-width: 860px) {
    display: none;
  }
`;

export const DropdownItem = styled.li`
  position: relative;

  &:hover ul {
    display: block;
  }
`;

export const DropdownMenu = styled.ul`
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  background: #fff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  list-style: none;
  padding: 10px 0;
  margin: 0;
  z-index: 1000;

  li {
    padding: 8px 20px;

    a {
      color: #333;
      text-decoration: none;
      font-size: 14px;

      &:hover {
        color: #eea746;
      }
    }
  }
`;

export const UlWrapperRight = styled.ul`
  @media (max-width: 760px) {
    display: none;
  }
`;

export const MobileMenuIcon = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 24px;
  height: 18px;
  cursor: pointer;

  span {
    display: block;
    height: 2px;
    width: 100%;
    background-color: #008394;
    border-radius: 2px;
    transition: all 0.3s ease;
  }

  &:hover span {
    background-color: #eea746;
  }

  @media (min-width: 860px) {
    display: none;
  }
`;

export const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  @media (min-width: 860px) {
    width: auto;
  }
`;

export const NavLinkItem = styled.li`
  list-style: none;
  padding: 0;
  margin: 0 5px;
  
  a {
    display: block;
    padding: 10px 15px;
    color: #333;
    text-decoration: none;
    position: relative;
    transition: color 0.3s ease;
    
    &:hover {
      color: #eea746;
    }
    
    &.active {
      color: #eea746;
      
      &:after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 15px;
        right: 15px;
        height: 3px;
        background-color: #eea746;
        border-radius: 1.5px;
      }
    }
  }
  
  @media (min-width: 1024px) {
    margin: 0 10px;
  }
`;


export const MobileMenu = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 85%;
  max-width: 320px;
  background-color: white;
  box-shadow: -5px 0 15px rgba(0, 0, 0, 0.1);
  padding: 30px 20px;
  z-index: 1000;
  transform: ${({ isOpen }) => (isOpen ? "translateX(0)" : "translateX(100%)")};
  transition: transform 0.3s ease-in-out;
  overflow-y: auto;
  
  .mobile-auth {
    margin-top: 30px;
    padding-top: 20px;
    border-top: 1px solid #eee;
  }
  
  .mobile-btn-wrapper {
    margin-top: 20px;
    padding: 0 10px;
  }
  
  .profile-link {
    display: inline-block;
    margin-top: 10px;
    padding: 10px 20px;
    background-color: #f8f8f8;
    color: #333;
    border-radius: 8px;
    width: auto;
    
    &:hover {
      background-color: #eea746;
      color: white;
    }
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 15px;
  right: 15px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #333;
  height: 30px;
  width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
`;

export const MobileNavLink = styled.div`
  margin: 10px 0;
  
  a {
    display: block;
    padding: 12px 10px;
    color: #333;
    text-decoration: none;
    font-size: 16px;
    border-radius: 8px;
    transition: all 0.2s ease;
    
    &:hover, &.active {
      background-color: rgba(238, 167, 70, 0.1);
      color: #eea746;
    }
  }
`;

export const MobileDropdownToggle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 10px;
  cursor: pointer;
  border-radius: 8px;
  
  span {
    font-size: 18px;
    margin-left: 10px;
  }
  
  &:hover {
    background-color: rgba(238, 167, 70, 0.05);
    color: #eea746;
  }
`;

export const MobileDropdownMenu = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  max-height: ${({ isOpen }) => (isOpen ? "500px" : "0")};
  overflow: hidden;
  transition: max-height 0.3s ease;
  background-color: #f8f8f8;
  border-radius: 8px;
  margin-left: 10px;
  
  li {
    margin: 0;
    
    a {
      display: block;
      padding: 12px 20px;
      color: #333;
      text-decoration: none;
      font-size: 15px;
      transition: all 0.2s ease;
      
      &:hover, &.active {
        color: #eea746;
      }
    }
  }
`;
